/** Ordered multilingual keywords — English first, then other locales */
const SEO_KEYWORDS_ORDERED = [
  // en (first)
  'calculator',
  'scientific calculator',
  'online calculator',
  'web calculator',
  'free calculator',
  'math calculator',
  'logarithm',
  'factorial',
  'square root',
  // zh-CN
  '计算器',
  '科学计算器',
  '在线计算器',
  '网页计算器',
  '免费计算器',
  '数学计算器',
  '对数',
  '阶乘',
  '平方根',
  // fr
  'calculatrice',
  'calculatrice scientifique',
  'calculatrice en ligne',
  'calculatrice gratuite',
  'logarithme',
  'factorielle',
  'racine carrée',
  'mathématiques',
  // de
  'Rechner',
  'Taschenrechner',
  'wissenschaftlicher Rechner',
  'Online-Rechner',
  'Logarithmus',
  'Fakultät',
  'Quadratwurzel',
  'Mathematik',
  // ja
  '電卓',
  '関数電卓',
  'オンライン電卓',
  '対数',
  '階乗',
  '平方根',
  '数学',
  // ko
  '계산기',
  '공학용 계산기',
  '온라인 계산기',
  '로그',
  '팩토리얼',
  '제곱근',
  '수학',
  // es
  'calculadora',
  'calculadora científica',
  'calculadora en línea',
  // pt
  'calculadora científica',
  'calculadora online',
  // it
  'calcolatrice',
  'calcolatrice scientifica',
  // ru
  'калькулятор',
  'научный калькулятор',
  // zh-TW
  '計算機',
  '科學計算機',
  '線上計算機',
  // nl
  'rekenmachine',
  'wetenschappelijke rekenmachine',
];

export const SEO_KEYWORDS_GLOBAL = SEO_KEYWORDS_ORDERED.join(', ');

/** Static HTML fallback before Vue hydrates meta */
export const SEO_DESCRIPTION_FALLBACK =
  'Free online scientific calculator with logarithms, factorials, and square roots. ' +
  '免费在线科学计算器 | Calculatrice scientifique | Wissenschaftlicher Rechner | 関数電卓 | 공학용 계산기.';

function splitKeywords(raw: string): string[] {
  return raw
    .split(/[,，、]+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function mergeSeoKeywords(localeKeywords: string): string {
  const seen = new Set<string>();
  const result: string[] = [];

  const push = (term: string) => {
    const key = term.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    result.push(term);
  };

  for (const term of SEO_KEYWORDS_ORDERED) push(term);
  for (const term of splitKeywords(localeKeywords)) push(term);

  return result.join(', ');
}
